import {StickyNavigationMenuActiveIndicatorRailDefaultBox} from "./sticky-navigation-menu-active-indicator-rail.default.box";

export const StickyNavigationMenuActiveIndicatorRailBox = StickyNavigationMenuActiveIndicatorRailDefaultBox;
